import { render, staticRenderFns } from "./OriginDialog.vue?vue&type=template&id=3f5a558c"
import script from "./OriginDialog.vue?vue&type=script&lang=js"
export * from "./OriginDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports